import { Link } from 'react-router-dom'
import {connect} from 'react-redux'
import React, { Component } from 'react'
import changeMain from '../actions/main'

class Sidebar extends Component {
  render() {
    let { handleClick } = this.props

    let links = this.props.sidebars.map( (sidebar, index) => {
        
        let dropdownLinks = sidebar.children.map( (child, index) => {
            let clk = child.type === 'endpoint' ? () => handleClick(child) : null
            let routePath = child.label.toLowerCase()
            return (
                <li key={index} className="collection-item">
                    <Link to={`/${routePath}`} className="link" onClick={clk}>
                        {child.label}
                    </Link>
                </li>
            )
        })

        let innerLinksWrapper = dropdownLinks.length ? 
            <div className="collapsible-body">
                <ul className="collection">
                    {dropdownLinks}
                </ul>
            </div>: null
        
        let routePath = sidebar.label.toLowerCase()
        return (
            <li key={index}>
                <div className="collapsible-header waves-effect waves-light">  
                    <Link to={`/${routePath}`} onClick={() => handleClick(sidebar)}>                      
                        <i className={sidebar.icon}></i>{sidebar.label}  
                    </Link>                      
                </div>
                { innerLinksWrapper }
            </li>
        )
    })

    return (

      <div id="side-nav-bar" className="side-nav-bar">
        <Link to={'/'}>
        {/* <div className="side-bar-header">
            <img src="./img/eym-io.png" alt=""/>
        </div> */}
        </Link>
        <ul id="main-nav" className="collapsible">
            {links}
        </ul>
      </div>

    )
  }
}

function mapStateToProps(state){
    return {
        sidebars: state.sidebars
    }
}

function mapDispatchToProps(dispatch){
    return {
        handleClick: (sidebar) => {
            dispatch(changeMain({
                endpointId: sidebar.endpointId ? sidebar.endpointId: null ,
                endpointListId: null
            }))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Sidebar)


// WEBPACK FOOTER //
// ./src/components/sidebar.js